// NuevaCitaPage.tsx
import React from 'react';
import { usePOS } from '../../../context/POSContext';
import ReservasWorkspace from './ReservasWorkspace';
import PuntoDeVentaProducto from './PuntoDeVentaProducto';
import { X } from 'lucide-react';

const C = {
    primary: '#FF2052',
    secondary: '#007FC8',
    secondaryLight: '#00DBB9',
};

const NuevaCitaPage: React.FC = () => {
    const { operadorActivo, sesionActiva, puntoDeVenta, sucursalId, cargandoSesion } = usePOS();
    // Pantalla de carga / sin sesión (heredada)
    if (cargandoSesion) return (
        <div style={{ display:'flex', height:'100%', background:'#fff', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'16px' }}>
            <div style={{ width:'40px', height:'40px', border:`3px solid ${C.secondary}`, borderTopColor:'transparent', borderRadius:'50%', animation:'spin .7s linear infinite' }} />
            <p style={{ color:'#64748b', fontWeight:'600' }}>Cargando sesión POS...</p>
        </div>
    );
    if (!sesionActiva || !puntoDeVenta) return (
        <div style={{ display:'flex', height:'100%', background:'#fff', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'12px' }}>
            <div style={{ width:'56px', height:'56px', borderRadius:'16px', background:`${C.primary}10`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <X size={24} color={C.primary} />
            </div>
            <p style={{ fontSize:'1.1rem', fontWeight:'900', color:'#0f172a' }}>Sin sesión POS activa</p>
        </div>
    );

    if (!sucursalId) return null;

    // Solo un módulo habilitado
    if (puntoDeVenta.habilitar_citas) {
        return <ReservasWorkspace key={`${sucursalId}|${sesionActiva.id}|${puntoDeVenta.id}|${operadorActivo?.token ?? ""}`} />;
    }
    if (puntoDeVenta.habilitar_cafeteria) {
        return <PuntoDeVentaProducto sesionActiva={sesionActiva} puntoDeVenta={puntoDeVenta} operadorToken={operadorActivo?.token ?? null} />;
    }

    // Fallback
    return null;
};

export default NuevaCitaPage;

